"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbtack } from "@fortawesome/free-solid-svg-icons";
import { useMyStream } from "@/contexts/wave/MyStreamContext";
import { Tooltip } from "react-tooltip";
import { useAuth } from "@/components/auth/Auth";
import { usePinnedWavesServer, MAX_PINNED_WAVES } from "@/hooks/usePinnedWavesServer";
interface BrainLeftSidebarWavePinProps {
  readonly waveId: string;
  readonly isPinned: boolean;
}
const BrainLeftSidebarWavePin: React.FC<BrainLeftSidebarWavePinProps> = t0 => {
  const $ = _c(54);
  const {
    waveId,
    isPinned
  } = t0;
  const {
    waves
  } = useMyStream();
  const {
    pinnedIds,
    isOperationInProgress,
    canPinWave
  } = usePinnedWavesServer();
  const {
    setToast
  } = useAuth();
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const [showMaxLimitTooltip, setShowMaxLimitTooltip] = useState(false);
  let t1;
  if ($[0] !== isOperationInProgress || $[1] !== waveId) {
    t1 = isOperationInProgress(waveId);
    $[0] = isOperationInProgress;
    $[1] = waveId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isCurrentlyProcessing = t1;
  let t2;
  if ($[3] !== canPinWave || $[4] !== waveId) {
    t2 = canPinWave(waveId);
    $[3] = canPinWave;
    $[4] = waveId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const canPinCurrentWave = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setShowMaxLimitTooltip(false);
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isPinned) {
    t4 = [isPinned];
    $[7] = isPinned;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== canPinCurrentWave) {
    t5 = () => {
      if (canPinCurrentWave) {
        setShowMaxLimitTooltip(false);
      }
    };
    $[9] = canPinCurrentWave;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== canPinCurrentWave || $[12] !== pinnedIds) {
    t6 = [pinnedIds, canPinCurrentWave];
    $[11] = canPinCurrentWave;
    $[12] = pinnedIds;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[14] !== showMaxLimitTooltip) {
    t7 = () => {
      if (!showMaxLimitTooltip) {
        return;
      }
      const timer = setTimeout(() => setShowMaxLimitTooltip(false), 3000);
      return () => clearTimeout(timer);
    };
    t8 = [showMaxLimitTooltip];
    $[14] = showMaxLimitTooltip;
    $[15] = t7;
    $[16] = t8;
  } else {
    t7 = $[15];
    t8 = $[16];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      const checkTouch = () => {
        setIsTouchDevice("ontouchstart" in window || navigator.maxTouchPoints > 0 || window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
      };
      checkTouch();
      window.addEventListener("resize", checkTouch);
      return () => {
        window.removeEventListener("resize", checkTouch);
      };
    };
    t10 = [];
    $[17] = t10;
    $[18] = t9;
  } else {
    t10 = $[17];
    t9 = $[18];
  }
  useEffect(t9, t10);
  let t11;
  if ($[19] !== canPinWave || $[20] !== isCurrentlyProcessing || $[21] !== isPinned || $[22] !== setToast || $[23] !== waveId || $[24] !== waves) {
    t11 = async e => {
      e.stopPropagation();
      e.preventDefault();
      if (isCurrentlyProcessing) {
        return;
      }
      ;
      try {
        if (isPinned) {
          waves.removePinnedWave(waveId);
          setShowMaxLimitTooltip(false);
        } else {
          const canPin = canPinWave(waveId);
          if (canPin) {
            waves.addPinnedWave(waveId);
          } else {
            setShowMaxLimitTooltip(true);
            setToast({
              type: "error",
              message: `Maximum ${MAX_PINNED_WAVES} pinned waves allowed`
            });
          }
        }
      } catch (t12) {
        const error = t12;
        console.error("Error updating wave pin status:", error);
        const errorMessage = error instanceof Error ? error.message : "Something went wrong";
        setToast({
          type: "error",
          message: `Failed to ${isPinned ? "unpin" : "pin"} wave: ${errorMessage}`
        });
      }
    };
    $[19] = canPinWave;
    $[20] = isCurrentlyProcessing;
    $[21] = isPinned;
    $[22] = setToast;
    $[23] = waveId;
    $[24] = waves;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const handleClick = t11;
  let t12;
  if ($[26] !== isPinned || $[27] !== isTouchDevice) {
    t12 = () => {
      if (isTouchDevice) {
        return "tw-opacity-100";
      }
      if (isPinned) {
        return "tw-opacity-100";
      }
      return "tw-opacity-0 group-hover:tw-opacity-100";
    };
    $[26] = isPinned;
    $[27] = isTouchDevice;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const getOpacityClass = t12;
  const opacityClass = getOpacityClass();
  let t13;
  if ($[29] !== canPinCurrentWave || $[30] !== isPinned) {
    t13 = () => {
      if (isPinned) {
        return "Unpin";
      }
      if (canPinCurrentWave) {
        return "Pin";
      }
      return `Max ${MAX_PINNED_WAVES} pinned waves. Unpin another wave first.`;
    };
    $[29] = canPinCurrentWave;
    $[30] = isPinned;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const getTooltipContent = t13;
  const tooltipContent = getTooltipContent();
  let t14;
  if ($[32] !== isPinned) {
    t14 = () => {
      if (isPinned) {
        return "tw-text-iron-200 tw-bg-iron-700 desktop-hover:hover:tw-bg-iron-650 desktop-hover:hover:tw-text-iron-100 tw-opacity-100";
      }
      return "tw-text-iron-500 desktop-hover:hover:tw-text-iron-300 desktop-hover:hover:tw-bg-iron-700 tw-bg-transparent active:tw-bg-iron-700 tw-opacity-70";
    };
    $[32] = isPinned;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  const getButtonStyles = t14;
  let t15;
  if ($[34] !== isPinned) {
    t15 = () => isPinned ? "Unpin wave" : "Pin wave";
    $[34] = isPinned;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const getAriaLabel = t15;
  const t16 = `-tw-mr-2 tw-mt-0.5 tw-flex tw-size-7 tw-items-center tw-justify-center tw-rounded-md tw-border-0 tw-transition-all tw-duration-200 sm:tw-size-6 ${opacityClass} ${getButtonStyles()} ${isCurrentlyProcessing ? "tw-cursor-not-allowed tw-opacity-50" : ""}`;
  const t17 = getAriaLabel();
  const t18 = `wave-pin-${waveId}`;
  const t19 = `tw-size-2.5 tw-flex-shrink-0 ${isPinned ? "tw-rotate-[-45deg]" : ""}`;
  let t20;
  if ($[36] !== t19) {
    t20 = <FontAwesomeIcon icon={faThumbtack} className={t19} />;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== handleClick || $[39] !== isCurrentlyProcessing || $[40] !== t16 || $[41] !== t17 || $[42] !== t18 || $[43] !== t20) {
    t21 = <button onClick={handleClick} disabled={isCurrentlyProcessing} className={t16} aria-label={t17} data-tooltip-id={t18}>{t20}</button>;
    $[38] = handleClick;
    $[39] = isCurrentlyProcessing;
    $[40] = t16;
    $[41] = t17;
    $[42] = t18;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  const t22 = `wave-pin-${waveId}`;
  let t23;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== tooltipContent) {
    t24 = <span className="tw-text-xs">{tooltipContent}</span>;
    $[46] = tooltipContent;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t22 || $[49] !== t24) {
    t25 = <Tooltip id={t22} place="top" style={t23}>{t24}</Tooltip>;
    $[48] = t22;
    $[49] = t24;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t21 || $[52] !== t25) {
    t26 = <>{t21}{t25}</>;
    $[51] = t21;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  return t26;
};
export default BrainLeftSidebarWavePin;